module.exports = __webpack_public_path__ + "media/assets/images/landings/iot/screens/dashboard_chart_resize-75d5e81fb2958ff4ae5c6661b256ccf4.png";